const EVENT_NAME = 'aleph:close-dropdowns';

export function closeAllDropdowns(): void {
  window.dispatchEvent(new Event(EVENT_NAME));
}

export function onCloseDropdowns(handler: () => void): () => void {
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
}
